
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import { ValidationProvider } from 'vee-validate';
import { en, fr } from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';
import '@/validation-rules';

@Component({
	components: { ValidationProvider, Datepicker }
})
export default class EventDetailsSection extends Vue {
	@Prop({ type: Object, required: true }) private formData!: { event_date: Date | null; num_people: number | null };
	@Prop({ type: String, required: false, default: 'America/Toronto' }) private timezone!: string;

	private datepickerLocales: object = { en, fr };
	private numPeopleHasInput: boolean = false;

	private get disabledDates(): object {
		const yesterday = DateTime.now().setZone(this.timezone).minus({ days: 1 }).endOf('day').toJSDate();
		return { to: yesterday };
	}

	/**
	 * Handle num_people input
	 * Tracks whether the field has any value (including invalid input like letters),
	 * to ensure that the input label stays floated up even with invalid input
	 *
	 * @param {InputEvent} event
	 * @return {void}
	 */
	private onNumPeopleInput(event: InputEvent): void {
		const input = event.target as HTMLInputElement;
		this.numPeopleHasInput = input.value !== '' || input.validity.badInput;
		const value = this.numPeopleHasInput && input.value !== '' ? Number(input.value) : null;
		this.$emit('update-field', 'num_people', value);
	}
}
